export var Severity;
(function (Severity) {
    Severity["Fatal"] = "fatal";
    Severity["Error"] = "error";
    Severity["Warning"] = "warning";
    Severity["Log"] = "log";
    Severity["Info"] = "info";
    Severity["Debug"] = "debug";
})(Severity || (Severity = {}));
//# sourceMappingURL=errorLogging.types.js.map